export default {
    accounts_main_id: 'Id',
    accounts_main_name: 'Name',
    accounts_main_dealer: 'Dealer',
    accounts_main_brand: 'Brand',
    accounts_main_status: 'Status',
    accounts_main_companies: 'Companies',
    accounts_main_accounts: 'Accounts',
    accounts_main_advanced_filters: 'Advanced Filters',
    accounts_main_apply: 'Apply',
    accounts_main_tags: 'Tags',
    accounts_main_active_accounts_only: 'Active Accounts Only',
    accounts_main_yes: 'Yes',
    accounts_main_no: 'No',
    accounts_main_authenticate_cloud: 'Login as Customer',
    accounts_main_re_sync_backend_information: 'Re-sync Backend Information',
    accounts_main_devices: 'Devices',
    accounts_main_package: 'Package',
    accounts_main_crm: 'Salesforce Id',
    accounts_main_add_account: 'Add Account',
    accounts_main_import_account: 'Import Account',
    accounts_main_edit: 'Edit',
    accounts_main_remove_filters: 'Remove filters',
    accounts_main_account_details: 'Account Details',
    accounts_main_import_from_p4: 'Import From P4',
    accounts_main_reprocess_odo_hours: 'Reprocess Odo/Hrs',
    accounts_main_new_status: 'New Status',
    accounts_main_at: 'at',
    accounts_main_next_scheduled_action: 'Next scheduled action on',
    accounts_main_on: 'on',
    accounts_main_tags: 'Tags',
    accounts_main_syncZonar: 'Sync Zonar',
    accounts_main_error_integration_zonar: 'No integration with Zonar',
    accounts_main_readonly: 'Read Only',
    accounts_main_edge_tensor: 'AI Video Reviews',
    accounts_main_status_filter: 'Account Status',
};